import VulsPeriodLineChart from './VulCharts/1VulsPeriodLineChart/1vulsPeriodLineChart';

interface PageProps {
  slug: string;
}

const VulsPage: React.FC<PageProps> = ({ slug }) => {
  return (
    <>
      <div className="row">
        <div className="col-md-12 my-2">
          <VulsPeriodLineChart slug={slug} />
        </div>
      </div>
    </>
  );
};

export default VulsPage;
